import { http } from './config'
import authHeader from './auth-header'

export default {
  listar: () => {
    return http.get('/etiqueta', {
      headers: authHeader(),
    })
  },

  listarPorOrigem: (origem) => {
    return http.get(`/etiqueta/origem/${encodeURIComponent(origem)}`, {
      headers: authHeader(),
    })
  },

  cadastrar: (payload) => {
    return http.post('/etiqueta', payload, {
      headers: {
        ...authHeader(),
        'Content-Type': 'application/json',
      },
    })
  },

  listarPorCliente: (idCliente) => {
    return http.get(`/cliente-etiqueta/cliente/${idCliente}`, {
      headers: authHeader(),
    })
  },

  associarCliente: (payload) => {
    return http.post('/cliente-etiqueta', payload, {
      headers: {
        ...authHeader(),
        'Content-Type': 'application/json',
      },
    })
  },
}
